/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/pt_BR';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "Acesse o lindo editor de HTML"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "Verificador de acessibilidade:"
  },
  "action_to_take_b626a99a": {
    "message": "Ação a tomar:"
  },
  "add_8523c19b": {
    "message": "Adicionar"
  },
  "add_a_caption_2a915239": {
    "message": "Adicionar legendas"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "Adicionar texto alternativo para a imagem"
  },
  "add_another_f4e50d57": {
    "message": "Adicionar outro"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "Adicionar legenda"
  },
  "add_image_60b2de07": {
    "message": "Adicionar imagem"
  },
  "add_one_9e34a6f8": {
    "message": "Adicionar uma!"
  },
  "additional_considerations_f3801683": {
    "message": "Considerações adicionais"
  },
  "address_applied_64269b0b": {
    "message": "Endereço aplicado"
  },
  "address_removed_fcb496e0": {
    "message": "Endereço removido"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "Links adjacentes com a mesma URL devem ser um único link."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "Alinhar"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "Alinhamento e listas"
  },
  "all_4321c3a1": {
    "message": "Todos"
  },
  "all_apps_a50dea49": {
    "message": "Todos os aplicativos"
  },
  "allow_media_download_16dcf2bd": {
    "message": "Permitir download de mídia"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "Permitir download da transcrição"
  },
  "alpha_15d59033": {
    "message": "Alfa"
  },
  "alphabetical_55b5b4e0": {
    "message": "Alfabética"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "Texto do atributo alternativo não deve ter mais de 120 caracteres."
  },
  "alt_text_611fb322": {
    "message": "Texto alternativo"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Coproduto)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "Ocorreu um erro ao ler o arquivo"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "Um erro ocorreu ao fazer uma solicitação de rede"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "Ocorreu um erro ao carregar a sua mídia."
  },
  "and_7fcc2911": {
    "message": "E"
  },
  "angle_c5b4ec50": {
    "message": "Ângulo"
  },
  "announcement_fb4cb645": {
    "message": "Aviso"
  },
  "announcement_list_da155734": {
    "message": "Lista de aviso"
  },
  "announcements_a4b8ed4a": {
    "message": "Avisos"
  },
  "apply_781a2546": {
    "message": "Aplicar"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "Aplicar as alterações a todas as instâncias deste ícone do Criador de Ícone"
  },
  "approaches_the_limit_893aeec9": {
    "message": "Aproxima-se do limite"
  },
  "approximately_e7965800": {
    "message": "Aproximadamente"
  },
  "apps_54d24a47": {
    "message": "Aplicativos"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "Tem certeza de que deseja cancelar? As alterações feitas não serão salvas."
  },
  "arrows_464a3e54": {
    "message": "Setas"
  },
  "art_icon_8e1daad": {
    "message": "Ícone de arte"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "Proporção do aspecto será preservado"
  },
  "assignment_976578a8": {
    "message": "Tarefa"
  },
  "assignments_1e02582c": {
    "message": "Tarefas"
  },
  "asterisk_82255584": {
    "message": "Asterisco"
  },
  "attributes_963ba262": {
    "message": "Atributos"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "Não há suporte para gravação de áudio e vídeo; por favor, use um navegador diferente."
  },
  "audio_options_feb58e2c": {
    "message": "Opções de áudio"
  },
  "audio_options_tray_33a90711": {
    "message": "Bandeja de opções de áudio"
  },
  "audio_player_for_title_20cc70d": {
    "message": "Reprodutor de áudio para { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "Conteúdo com salvamento automático existe. Gostaria de carregar o conteúdo com salvamento automático em seu lugar?"
  },
  "available_folders_694d0436": {
    "message": "Pastas disponíveis"
  },
  "background_1bc88842": {
    "message": "Contexto"
  },
  "backslash_b2d5442d": {
    "message": "Barra invertida"
  },
  "bar_ec63ed6": {
    "message": "Bar"
  },
  "basic_554cdc0a": {
    "message": "Básico"
  },
  "because_501841b": {
    "message": "Porque"
  },
  "below_81d4dceb": {
    "message": "Abaixo"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "Grande círculo"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "Coeficiente binomial"
  },
  "black_4cb01371": {
    "message": "Preto"
  },
  "blue_daf8fea9": {
    "message": "Azul"
  },
  "bold_applied_42d547b7": {
    "message": "Negrito aplicado"
  },
  "bold_removed_da474a5c": {
    "message": "Negrito removido"
  },
  "border_5b08b06d": {
    "message": "Limite"
  },
  "bottom_15a2a9be": {
    "message": "Inferior"
  },
  "bottom_third_5f5fec1d": {
    "message": "Terço inferior"
  },
  "bowtie_5f9629e4": {
    "message": "Gravata borboleta"
  },
  "brick_f2656265": {
    "message": "Tijolo"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "Cancelar"
  },
  "cap_product_3a5265a6": {
    "message": "Produto de limite"
  },
  "caption_manager_aae0906f": {
    "message": "Gerenciador de legendas"
  },
  "center_align_e68d9997": {
    "message": "Centralizar"
  },
  "centered_dot_64d5e378": {
    "message": "Ponto centralizado"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "Pontos horizontais centrados"
  },
  "change_alt_text_92654906": {
    "message": "Alterar texto alternativo"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "Alterar tag do título para parágrafo"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "Alterar apenas o nível deste cabeçalho"
  },
  "change_text_color_1aecb912": {
    "message": "Alterar cor do texto"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "As alterações serão aplicadas após você salvar esta página."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "As alterações feitas não serão salvas."
  },
  "characters_9d897d1c": {
    "message": "Caracteres"
  },
  "characters_no_spaces_485e5367": {
    "message": "Caracteres (sem espaços)"
  },
  "check_accessibility_3c78211c": {
    "message": "Verificar acessibilidade"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "Verificando problemas de acessibilidade"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "Escolher arquivo de legenda"
  },
  "choose_usage_rights_33683854": {
    "message": "Escolher direitos de uso..."
  },
  "circle_484abe63": {
    "message": "Circular"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "Lista não ordenada circular"
  },
  "clear_2084585f": {
    "message": "Limpar"
  },
  "clear_image_3213fe62": {
    "message": "Limpar imagem"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "Clique ou clique e segure Shift para o editor de html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "Clique para incorporar { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "Clique para ocultar a pré-visualização"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "Clique para inserir um link no editor."
  },
  "click_to_show_preview_faa27051": {
    "message": "Clique para mostrar a pré-visualização"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "Feche um menu ou diálogo. Também lhe retorna para a área do editor"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "Fechar Verificador de acessibilidade"
  },
  "close_d634289d": {
    "message": "Fechar"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "Fechar janela modal de atalhos de teclado"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "O arquivo de legenda oculta deve ter menos de { maxKb } kb"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "Legendas"
  },
  "clubs_suit_c1ffedff": {
    "message": "Clubes (terno)"
  },
  "collab_575ac7bc": {
    "message": "Colaboração"
  },
  "collaborations_5c56c15f": {
    "message": "Colaborações"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "Recolher para ocultar { types }"
  },
  "color_a363e1b0": {
    "message": "Cor"
  },
  "color_contrast_4c418add": {
    "message": "Contraste de cor"
  },
  "color_contrast_ratio_687782f0": {
    "message": "Taxa de contraste de cores"
  },
  "color_picker_6b359edf": {
    "message": "Selecionador de Cores"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "Seletor de cores ({ colorName } selecionado)"
  },
  "color_popup_af39810f": {
    "message": "Popup de cores"
  },
  "column_e1ae5c64": {
    "message": "Coluna"
  },
  "column_group_1c062368": {
    "message": "Grupo de colunas"
  },
  "complex_numbers_a543d004": {
    "message": "Números complexos"
  },
  "computer_1d7dfa6f": {
    "message": "Computador"
  },
  "congruent_5a244acd": {
    "message": "Congruente"
  },
  "contains_311f37b7": {
    "message": "Contém"
  },
  "content_1440204b": {
    "message": "Conteúdo"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "O conteúdo do editor será alterado. Pressione Cancelar para manter o conteúdo original."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "Conteúdo ainda está sendo carregado, se você continuar, ele não será incorporado adequadamente."
  },
  "content_subtype_5ce35e88": {
    "message": "Subtipo do conteúdo"
  },
  "content_type_2cf90d95": {
    "message": "Tipo de conteúdo"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "Continuar para o conteúdo do YouTube"
  },
  "coproduct_e7838082": {
    "message": "Coproduto"
  },
  "copyright_holder_66ee111": {
    "message": "Titular do Copyright:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "Não foi possível inserir o conteúdo: Os itens \"{ itemType }\" não são suportados atualmente no Canvas."
  },
  "count_40eced3b": {
    "message": "Contagem"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 palavras}\n    one {1 palavra}\n  other {# palavras}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# item carregado}\n  other {# itens carregados}\n}"
  },
  "course_documents_104d76e0": {
    "message": "Documentos do curso"
  },
  "course_files_62deb8f8": {
    "message": "Arquivos do Curso"
  },
  "course_files_a31f97fc": {
    "message": "Arquivos do curso"
  },
  "course_images_f8511d04": {
    "message": "Imagens do curso"
  },
  "course_link_b369426": {
    "message": "Link do curso"
  },
  "course_links_b56959b9": {
    "message": "Links do curso"
  },
  "course_media_ec759ad": {
    "message": "Mídia do curso"
  },
  "course_navigation_dd035109": {
    "message": "Navegação do curso"
  },
  "create_icon_110d6463": {
    "message": "Criar ícone"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "Criar ícone do Criador de Ícone"
  },
  "creative_commons_license_725584ae": {
    "message": "Licença do Creative Commons:"
  },
  "crop_image_41bf940c": {
    "message": "Cortar imagem"
  },
  "crop_image_807ebb08": {
    "message": "Cortar imagem"
  },
  "cup_product_14174434": {
    "message": "Produto copo"
  },
  "current_image_f16c249c": {
    "message": "Imagem atual"
  },
  "current_link_945a47ee": {
    "message": "Link atual"
  },
  "current_volume_level_c55ab825": {
    "message": "Nível do volume atual"
  },
  "custom_6979cd81": {
    "message": "Personalizar"
  },
  "cyan_c1d5f68a": {
    "message": "Ciano"
  },
  "dagger_57e0f4e5": {
    "message": "Punhal"
  },
  "date_added_ed5ad465": {
    "message": "Data adicionada"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "Ícone decorativo"
  },
  "decorative_image_fde98579": {
    "message": "Imagem decorativa"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "Decorativo { TYPE_UPPER }"
  },
  "decrease_indent_d9cf469d": {
    "message": "Diminuir Recuo"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "Diminuir a área de conteúdo avançado"
  },
  "deep_purple_bb3e2907": {
    "message": "Roxo Profundo"
  },
  "default_9db103d": {
    "message": "Padrão"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "Lista não ordenada padrão com marcadores"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "Lista ordenada padrão e numérica"
  },
  "definite_integral_fe7ffed1": {
    "message": "Integral definida"
  },
  "degree_symbol_4a823d5f": {
    "message": "Símbolo de grau"
  },
  "delimiters_4db4840d": {
    "message": "Delimitadores"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(Descreva o ícone)"
  },
  "describe_the_type_ff448da5": {
    "message": "(Descreva o { TYPE })"
  },
  "description_436c48d7": {
    "message": "Descrição"
  },
  "details_98a31b68": {
    "message": "Detalhes"
  },
  "diagonal_dots_7d71b57e": {
    "message": "Pontos diagonais"
  },
  "diamond_b8dfe7ae": {
    "message": "Losango"
  },
  "diamonds_suit_526abaaf": {
    "message": "Diamantes (terno)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "Tipo de dimensão"
  },
  "directionality_26ae9e08": {
    "message": "Direcionalidade"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "Editar diretamente LaTeX"
  },
  "disable_preview_222bdf72": {
    "message": "Desativar visualização"
  },
  "discussion_6719c51d": {
    "message": "Fórum"
  },
  "discussions_a5f96392": {
    "message": "Fóruns"
  },
  "discussions_index_6c36ced": {
    "message": "Índice de fóruns"
  },
  "disjoint_union_e74351a8": {
    "message": "União disjunta"
  },
  "display_options_315aba85": {
    "message": "Exibir opções"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "Exibir link de texto (abre em uma nova aba)"
  },
  "div_applied_49ad83fc": {
    "message": "Div aplicado"
  },
  "div_removed_d13f8e17": {
    "message": "Div removido"
  },
  "division_sign_72190870": {
    "message": "Sinal de divisão"
  },
  "document_678cd7bf": {
    "message": "Documento"
  },
  "documents_81393201": {
    "message": "Documentos"
  },
  "done_54e3d4b6": {
    "message": "Feito"
  },
  "double_dagger_faf78681": {
    "message": "Adaga dupla"
  },
  "down_5831a426": {
    "message": "Para baixo"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "Seta diagonal para baixo e esquerda"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "Seta diagonal para baixo e direita"
  },
  "download_filename_2baae924": {
    "message": "Baixar { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "Seta para baixo"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "Triângulo apontando para baixo"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "Arrastar um arquivo aqui"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "Arraste e solte ou clique para navegar no seu computador"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "Arraste a manilha. Use as setas para cima e para baixo para redimensionar"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "Vencimento: Várias datas"
  },
  "due_when_7eed10c6": {
    "message": "Vencimento: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "Editar texto alternativo para esta instância de ícone"
  },
  "edit_c5fbea07": {
    "message": "Editar"
  },
  "edit_course_link_5a5c3c59": {
    "message": "Editar link do curso"
  },
  "edit_equation_f5279959": {
    "message": "Editar equação"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "Editar ícone do criador de ícones existente"
  },
  "edit_icon_2c6b0e91": {
    "message": "Editar ícone"
  },
  "edit_link_7f53bebb": {
    "message": "Editar link"
  },
  "editor_status_bar_653f44ee": {
    "message": "Barra de status do editor"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "Elemento começando com { start }"
  },
  "embed_828fac4a": {
    "message": "Incorporar"
  },
  "embed_code_314f1bd5": {
    "message": "Código de incorporação"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "Incorporar conteúdo da ferramenta externa"
  },
  "embed_image_1080badc": {
    "message": "Imagem incorporada"
  },
  "embed_video_a97a64af": {
    "message": "Incorporar vídeo"
  },
  "embedded_content_aaeb4d3d": {
    "message": "conteúdo incorporado"
  },
  "empty_set_91a92df4": {
    "message": "Conjunto vazio"
  },
  "encircled_dot_8f5e51c": {
    "message": "Ponto circundado"
  },
  "encircled_minus_72745096": {
    "message": "Menos circundado"
  },
  "encircled_plus_36d8d104": {
    "message": "Mais circundado"
  },
  "encircled_times_5700096d": {
    "message": "Vezes circundado"
  },
  "engineering_icon_f8f3cf43": {
    "message": "Ícone de engenharia"
  },
  "english_icon_25bfe845": {
    "message": "Ícone de inglês"
  },
  "enter_a_media_title_81b490ec": {
    "message": "Insira um título de mídia"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "Insira pelo menos 3 caracteres para pesquisar"
  },
  "enter_replacement_text_17631bbc": {
    "message": "digite o texto de substituição"
  },
  "enter_search_text_26cb4459": {
    "message": "digite o texto de pesquisa"
  },
  "epsilon_54bb8afa": {
    "message": "Épsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Épsilon (variante)"
  },
  "equals_sign_c51bdc58": {
    "message": "Sinal de igual"
  },
  "equation_1c5ac93c": {
    "message": "Equação"
  },
  "equation_editor_39fbc3f1": {
    "message": "Editor de equação"
  },
  "equilibrium_6ff3040b": {
    "message": "Equilíbrio"
  },
  "equivalence_class_7b0f11c0": {
    "message": "Classe de equivalência"
  },
  "equivalent_identity_654b3ce5": {
    "message": "Equivalente (Identidade)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "Existe"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "Sair da tela cheia"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "Expandir visualização por padrão"
  },
  "expand_to_see_types_f5d29352": {
    "message": "Ampliar para ver { types }"
  },
  "external_link_d3f9e62a": {
    "message": "Link externo"
  },
  "external_tool_frame_70b32473": {
    "message": "Estrutura de ferramenta externa"
  },
  "external_tools_6e77821": {
    "message": "Ferramentas externas"
  },
  "extra_large_b6cdf1ff": {
    "message": "Muito grande"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "Extra grande ({ width } x { height } px)"
  },
  "extra_small_9ae33252": {
    "message": "Muito pequeno"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "Ícone extracurricular"
  },
  "f_function_fe422d65": {
    "message": "F (função)"
  },
  "fail_544e5dde": {
    "message": "FALHA"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "Falha ao obter o conteúdo do arquivo"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "Falha ao recuperar o conteúdo da ferramenta externa"
  },
  "file_name_8fd421ff": {
    "message": "Nome do arquivo"
  },
  "file_preview_21667a6e": {
    "message": "Pré-visualização do arquivo"
  },
  "file_preview_for_filename_ab314195": {
    "message": "Pré-visualização do arquivo para { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "Cota de armazenamento de arquivos excedida"
  },
  "file_url_c12b64be": {
    "message": "URL do arquivo"
  },
  "filename_file_icon_602eb5de": {
    "message": "Ícone do arquivo { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "Pré-visualização de imagem { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "Pré-visualização de texto de { filename }"
  },
  "files_c300e900": {
    "message": "Arquivos"
  },
  "files_index_af7c662b": {
    "message": "Índice de arquivos"
  },
  "find_8d605019": {
    "message": "Localizar"
  },
  "find_and_replace_6e345933": {
    "message": "Localizar e substituir"
  },
  "finish_bc343002": {
    "message": "Concluir"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "Corrigir hierarquia de títulos"
  },
  "flat_music_76d5a5c3": {
    "message": "Plano (música)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "Focar barra de ferramentas de opções do elemento"
  },
  "folder_tree_fbab0726": {
    "message": "Árvore de pastas"
  },
  "for_all_b919f972": {
    "message": "Para todos"
  },
  "format_4247a9c5": {
    "message": "Formato"
  },
  "format_as_a_list_142210c3": {
    "message": "Formatar como uma lista"
  },
  "formatting_5b143aa8": {
    "message": "Formatação"
  },
  "forward_slash_3f90f35e": {
    "message": "Barra para frente"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "Encontrou conteúdo com salvamento automático"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "Encontrou { count, plural,\n     =0 {# resultados}\n    one {# resultado}\n  other {# resultados}\n}"
  },
  "fraction_41bac7af": {
    "message": "Fração"
  },
  "fullscreen_873bf53f": {
    "message": "Tela cheia"
  },
  "gamma_1767928": {
    "message": "Gama"
  },
  "generating_preview_45b53be0": {
    "message": "Gerando pré-visualização..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "Imagens no formato GIF/PNG maiores que { size } KB não são suportadas no momento."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "Ir para a barra de menu do editor"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "Ir para a barra de ferramentas do editor"
  },
  "grades_a61eba0a": {
    "message": "Notas"
  },
  "graphics_text_bc9568bc": {
    "message": "Texto gráfico"
  },
  "greater_than_e98af662": {
    "message": "Melhor que"
  },
  "greater_than_or_equal_b911949a": {
    "message": "Maior ou igual"
  },
  "greek_65c5b3f7": {
    "message": "Grego"
  },
  "green_15af4778": {
    "message": "Verde"
  },
  "grey_a55dceff": {
    "message": "Cinza"
  },
  "group_documents_8bfd6ae6": {
    "message": "Agrupar documentos"
  },
  "group_files_4324f3df": {
    "message": "Arquivos do grupo"
  },
  "group_files_82e5dcdb": {
    "message": "Arquivos de grupo"
  },
  "group_images_98e0ac17": {
    "message": "Agrupar imagens"
  },
  "group_isomorphism_45b1458c": {
    "message": "Grupo isomorfismo"
  },
  "group_link_63e626b3": {
    "message": "Link do grupo"
  },
  "group_links_9493129e": {
    "message": "Agrupar links"
  },
  "group_media_2f3d128a": {
    "message": "Agrupar mídia"
  },
  "group_navigation_99f191a": {
    "message": "Navegação do grupo"
  },
  "h_bar_bb94deae": {
    "message": "Barra H"
  },
  "hat_ea321e35": {
    "message": "Chapéu"
  },
  "header_column_f27433cb": {
    "message": "Coluna do cabeçalho"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "Linha e coluna do cabeçalho"
  },
  "header_row_f33eb169": {
    "message": "Linha do cabeçalho"
  },
  "heading_2_5b84eed2": {
    "message": "Título 2"
  },
  "heading_3_2c83de44": {
    "message": "Título 3"
  },
  "heading_4_b2e74be7": {
    "message": "Título 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "Título { h } aplicado"
  },
  "heading_h_removed_745f24a6": {
    "message": "Título { h } removido"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "Níveis de títulos não devem ser pulados."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "Título começando com { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "Títulos não devem ter mais de 120 caracteres."
  },
  "health_icon_8d292eb5": {
    "message": "Ícone de saúde"
  },
  "hearts_suit_e50e04ca": {
    "message": "Corações (Terno)"
  },
  "height_69b03e15": {
    "message": "Altura"
  },
  "hexagon_d8468e0d": {
    "message": "Hexágono"
  },
  "hide_description_bfb5502e": {
    "message": "Ocultar descrição"
  },
  "hide_title_description_caf092ef": {
    "message": "Ocultar { title } descrição"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "Destaque um elemento para ativar a barra de ferramentas de opções do elemento"
  },
  "home_351838cd": {
    "message": "Página inicial"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "Como solicitar e editar legendas?"
  },
  "html_code_editor_fd967a44": {
    "message": "editor de código html"
  },
  "html_editor_fb2ab713": {
    "message": "Editor de HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "Você obteve permissão para usar este arquivo."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "Eu possuo o copyright"
  },
  "icon_215a1dc6": {
    "message": "Ícone"
  },
  "icon_8168b2f8": {
    "message": "ícone"
  },
  "icon_color_b86dd6d6": {
    "message": "Cor do ícone"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "Ícones do criador de ícones"
  },
  "icon_options_7e32746e": {
    "message": "Opções de ícone"
  },
  "icon_options_tray_2b407977": {
    "message": "Bandeja de opções de ícone"
  },
  "icon_preview_1782a1d9": {
    "message": "Prévia do ícone"
  },
  "icon_shape_30b61e7": {
    "message": "Forma do ícone"
  },
  "icon_size_9353edea": {
    "message": "Tamanho do ícone"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "Se deixado em branco, o texto do link será exibido como nome do link do curso"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "Se os direitos de uso forem necessários, o arquivo não será publicado até que seja ativado na página Arquivos."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "Se você não selecionar os direitos de uso agora, esse arquivo terá a publicação cancelada depois do seu carregamento ser realizado."
  },
  "image_8ad06": {
    "message": "Imagem"
  },
  "image_c1c98202": {
    "message": "imagem"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "Nomes de arquivos da imagem não devem ser usados como atributo alternativo descrevendo o conteúdo da imagem."
  },
  "image_options_5412d02c": {
    "message": "Opções de imagem"
  },
  "image_options_tray_90a46006": {
    "message": "Bandeja de opções de imagem"
  },
  "image_to_crop_3a34487d": {
    "message": "Imagem a cortar"
  },
  "image_with_filename_file_aacd7180": {
    "message": "Imagem com nome de arquivo { file }"
  },
  "images_7ce26570": {
    "message": "Imagens"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "Imagens devem incluir um atributo alternativo descrevendo o conteúdo da imagem."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "Porção imaginária (de número complexo)"
  },
  "in_element_of_19ca2f33": {
    "message": "Em (elemento de)"
  },
  "increase_indent_6af90f7c": {
    "message": "Aumentar recuo"
  },
  "increase_rich_content_area_340b775": {
    "message": "Aumentar a área de conteúdo avançado"
  },
  "indefinite_integral_6623307e": {
    "message": "Integral indefinida"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } de { max }"
  },
  "indigo_2035fc55": {
    "message": "Índigo"
  },
  "inference_fed5c960": {
    "message": "Inferência"
  },
  "infinity_7a10f206": {
    "message": "Infinity"
  },
  "input_field_for_alpha_678265fd": {
    "message": "Campo de entrada para alfa"
  },
  "input_field_for_blue_561e020a": {
    "message": "Campo de entrada para azul"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "Campo de entrada para verde"
  },
  "input_field_for_red_86a84615": {
    "message": "Campo de entrada para vermelho"
  },
  "insert_593145ef": {
    "message": "Inserir"
  },
  "insert_link_6dc23cae": {
    "message": "Inserir link"
  },
  "insert_math_equation_57c6e767": {
    "message": "Insira Equação da Matemática"
  },
  "integers_336344e1": {
    "message": "Inteiros"
  },
  "intersection_cd4590e4": {
    "message": "Interseção"
  },
  "invalid_description_991e23bb": {
    "message": "Descrição inválida"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "Entrada inválida."
  },
  "invalid_file_c11ba11": {
    "message": "Arquivo inválido"
  },
  "invalid_file_type_881cc9b2": {
    "message": "Tipo de arquivo inválido"
  },
  "invalid_url_cbde79f": {
    "message": "URL inválido"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "Problema { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "Itálico aplicado"
  },
  "italic_removed_17cbab6f": {
    "message": "Itálico removido"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (variante)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "Atalhos de Teclado"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "Teclados navegam para links usando a tecla Tab. Dois links adjacentes que direcionam para o mesmo destino podem ser confusos para usuários de teclado."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "Ícone de artes linguísticas"
  },
  "languages_icon_9d20539": {
    "message": "Ícone de idiomas"
  },
  "large_9c5e80e7": {
    "message": "Grande"
  },
  "large_text_e7ba08cd": {
    "message": "Texto grande"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "Grande ({ width } x { height } px)"
  },
  "learn_ad3b3505": {
    "message": "Aprender"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "Saiba mais sobre links adjacentes"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "Saiba mais sobre o contraste de cores"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "Saiba mais sobre a organização de cabeçalhos da página"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "Saiba mais sobre a estrutura adequada do cabeçalho da página"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "Saiba mais sobre cabeçalhos de tabelas"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "Saiba mais sobre o uso de texto alternativo para imagens"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "Saiba mais sobre o uso de legendas com tabelas"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "Saiba mais sobre o uso de nomes de arquivos como texto alternativo"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "Saiba mais sobre o uso de listas"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "Saiba mais sobre o uso de atributos de escopo com tabelas"
  },
  "leave_as_is_4facfe55": {
    "message": "Deixar como está"
  },
  "left_3ea9d375": {
    "message": "Esquerda"
  },
  "left_align_43d95491": {
    "message": "Alinhar à esquerda"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Suporte de ângulo esquerdo"
  },
  "left_arrow_4fde1a64": {
    "message": "Seta para a esquerda"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Seta para a esquerda com gancho"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Teto esquerdo"
  },
  "left_curly_brace_1726fb4": {
    "message": "Chave esquerda"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Flecha de arpão para baixo esquerda"
  },
  "left_floor_29ac2274": {
    "message": "Piso esquerdo"
  },
  "left_to_right_e9b4fd06": {
    "message": "Esquerda à direita"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Flecha de arpão para cima para a esquerda"
  },
  "leftward_arrow_1e4765de": {
    "message": "Seta para a esquerda"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Triângulo apontando para a esquerda"
  },
  "less_than_a26c0641": {
    "message": "Menos que"
  },
  "less_than_or_equal_be5216cb": {
    "message": "Menor ou igual"
  },
  "library_icon_ae1e54cf": {
    "message": "Ícone da biblioteca"
  },
  "light_blue_5374f600": {
    "message": "Azul Claro"
  },
  "link_7262adec": {
    "message": "Link"
  },
  "link_options_a16b758b": {
    "message": "Opções de link"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "tipo de link: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "Link com texto começando com { start }"
  },
  "links_14b70841": {
    "message": "Links"
  },
  "links_to_an_external_site_de74145d": {
    "message": "Links para um site externo."
  },
  "lists_cd1336fc": {
    "message": "Listas"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "Listas devem ser formatadas como listas."
  },
  "load_more_35d33c7": {
    "message": "Carregar mais"
  },
  "loading_25990131": {
    "message": "Carregando..."
  },
  "loading_bde52856": {
    "message": "Carregando"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "Falha ao carregar legendas ocultas."
  },
  "loading_external_tool_d839042c": {
    "message": "Carregando ferramenta externa"
  },
  "loading_failed_b3524381": {
    "message": "Falha no carregamento..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "Falha no carregamento."
  },
  "loading_folders_d8b5869e": {
    "message": "Carregando pastas"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "Carregando espaço reservado para { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "Carregando, por favor aguarde"
  },
  "loading_preview_9f077aa1": {
    "message": "Carregando prévia"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "Velocidade de bloqueio em 1x"
  },
  "locked_762f138b": {
    "message": "Bloqueado(a)"
  },
  "logical_equivalence_76fca396": {
    "message": "Equivalência lógica"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "Equivalência lógica (curta)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "Equivalência lógica (curta e grossa)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "Equivalência lógica (espesso)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "Pontos horizontais baixos"
  },
  "magenta_4a65993c": {
    "message": "Magenta"
  },
  "maps_to_e5ef7382": {
    "message": "Mapas para"
  },
  "math_icon_ad4e9d03": {
    "message": "Ícone de matemática"
  },
  "media_af190855": {
    "message": "Mídia"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "O arquivo de mídia está sendo processado. Por favor, tente novamente mais tarde."
  },
  "media_options_saved_560c4ec8": {
    "message": "Opções de mídia salvas."
  },
  "media_title_2112243b": {
    "message": "Título da mídia"
  },
  "medium_5a8e9ead": {
    "message": "Média"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "Médio ({ width } x { height } px)"
  },
  "merge_links_2478df96": {
    "message": "Mesclar links"
  },
  "mic_a7f3d311": {
    "message": "Mic"
  },
  "microphone_disabled_15c83130": {
    "message": "Microfone desativado"
  },
  "middle_27dc1d5": {
    "message": "Meio"
  },
  "minimize_file_preview_da911944": {
    "message": "Minimizar pré-visualização de arquivo"
  },
  "minimize_video_20aa554b": {
    "message": "Minimizar vídeo"
  },
  "minus_fd961e2e": {
    "message": "Menos"
  },
  "minus_plus_3461f637": {
    "message": "Menos/mais"
  },
  "misc_3b692ea7": {
    "message": "Diversos"
  },
  "miscellaneous_e9818229": {
    "message": "Diversos"
  },
  "module_90d9fd32": {
    "message": "Módulo"
  },
  "modules_c4325335": {
    "message": "Módulos"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "Movendo a imagem para recortar { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "Imagem multicolorida"
  },
  "multiplication_sign_15f95c22": {
    "message": "Sinal de multiplicação"
  },
  "music_icon_4db5c972": {
    "message": "Ícone de música"
  },
  "my_files_2f621040": {
    "message": "Meus arquivos"
  },
  "n_th_root_9991a6e4": {
    "message": "N-ésima raiz"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "Nome"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Natural (música)"
  },
  "natural_numbers_3da07060": {
    "message": "Números naturais"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "Navegue no menu ou barra de ferramentas"
  },
  "navigation_ee9af92d": {
    "message": "Navegação"
  },
  "nested_greater_than_d852e60d": {
    "message": "Aninhado maior que"
  },
  "nested_less_than_27d17e58": {
    "message": "Aninhado menos de"
  },
  "new_quiz_34aacba6": {
    "message": "Novo teste"
  },
  "next_40e12421": {
    "message": "Próximo"
  },
  "next_findtext_9d69f0fe": {
    "message": "Próximo { findText }"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "Sem problemas de acessibilidades detectados."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "Nenhum anúncio criado ainda."
  },
  "no_announcements_found_20185afc": {
    "message": "Nenhum anúncio encontrado."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "Nenhuma tarefa criada ainda."
  },
  "no_assignments_found_79e46d7f": {
    "message": "Nenhuma tarefa encontrada."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "Não há alterações para salvar."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "Nenhuma discussão criada ainda."
  },
  "no_discussions_found_9284063b": {
    "message": "Nenhuma discussão encontrada."
  },
  "no_e16d9132": {
    "message": "Não"
  },
  "no_file_chosen_9a880793": {
    "message": "Nenhum arquivo escolhido"
  },
  "no_headers_9bc7dc7f": {
    "message": "Sem cabeçalhos"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "Nenhum módulo criado ainda."
  },
  "no_modules_found_2df43a40": {
    "message": "Nenhum módulo encontrado."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "Nenhuma página criada ainda."
  },
  "no_pages_found_6799350": {
    "message": "Nenhuma página encontrada."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "Nenhuma pré-visualização disponível para esse arquivo."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "Nenhum teste criado ainda."
  },
  "no_quizzes_found_c80c537a": {
    "message": "Nenhum teste encontrado."
  },
  "no_results_940393cf": {
    "message": "Sem resultados."
  },
  "no_results_found_58717065": {
    "message": "Nenhum resultado encontrado"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "Nenhum resultado encontrado para { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "Nenhum vídeo"
  },
  "none_3b5e34d2": {
    "message": "Nenhum"
  },
  "none_selected_b93d56d2": {
    "message": "Nenhum selecionado"
  },
  "normal_text_7b03da48": {
    "message": "Texto normal"
  },
  "not_equal_6e2980e6": {
    "message": "Não igual"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Não em (não é um elemento de)"
  },
  "not_negation_1418ebb8": {
    "message": "Não (negação)"
  },
  "not_subset_dc2b5e84": {
    "message": "Sem subconjunto"
  },
  "not_subset_strict_23d282bf": {
    "message": "Sem subconjunto (estrito)"
  },
  "not_superset_5556b913": {
    "message": "Sem superconjunto"
  },
  "not_superset_strict_24e06f36": {
    "message": "Sem superconjunto (estrito)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "Octógono"
  },
  "olive_6a3e4d6b": {
    "message": "Verde-oliva"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "Um dos seguintes estilos deve ser adicionado para salvar um ícone: Cor do ícone, tamanho do contorno, texto do ícone ou imagem"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "Falha ao colar um ou mais arquivos. Por favor, tente carregar ou arrastar e soltar arquivos."
  },
  "open_circle_e9bd069": {
    "message": "Círculo aberto"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "Abrir esta caixa de atalhos do teclado"
  },
  "open_title_application_fd624fc5": {
    "message": "Abrir o aplicativo { title }"
  },
  "operators_a2ef9a93": {
    "message": "Operadores"
  },
  "options_3ab0ea65": {
    "message": "Opções"
  },
  "or_9b70ccaa": {
    "message": "Ou"
  },
  "orange_81386a62": {
    "message": "Laranja"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "Listas ordenadas e não ordenadas"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "Outros atalhos do editor podem ser encontrados em"
  },
  "outline_color_3ef2cea7": {
    "message": "Cor do contorno"
  },
  "outline_size_a6059a21": {
    "message": "Tamanho do contorno"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } não é um protocolo válido."
  },
  "page_50c4823d": {
    "message": "Página"
  },
  "pages_e5414c2c": {
    "message": "Páginas"
  },
  "paragraph_5e5ad8eb": {
    "message": "Parágrafo"
  },
  "paragraph_applied_959b3fe5": {
    "message": "Parágrafo aplicado"
  },
  "paragraph_removed_d09320e": {
    "message": "Parágrafo removido"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "Parágrafo começando com { start }"
  },
  "parallel_d55d6e38": {
    "message": "Paralelo"
  },
  "partial_derivative_4a9159df": {
    "message": "Parcial (Derivativo)"
  },
  "pass_1c19a2b3": {
    "message": "APROVADO"
  },
  "paste_5963d1c1": {
    "message": "Colar"
  },
  "pause_12af3bb4": {
    "message": "Pausar"
  },
  "pentagon_17d82ea3": {
    "message": "Pentágono"
  },
  "people_b4ebb13c": {
    "message": "Pessoas"
  },
  "percentage_34ab7c2c": {
    "message": "Porcentagem"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "O percentual deve ser um número"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "A porcentagem deve ser de pelo menos { percentage }%"
  },
  "performing_arts_icon_f3497486": {
    "message": "Ícone de artes cênicas"
  },
  "perpendicular_7c48ede4": {
    "message": "Perpendicular"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (variante)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "Ícone de educação física"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (variante)"
  },
  "pick_a_color_557abfb0": {
    "message": "Escolha uma cor"
  },
  "pink_68ad45cb": {
    "message": "Rosa"
  },
  "pixels_52ece7d1": {
    "message": "Pixels"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "Os pixels devem ter pelo menos { width } x { height }px"
  },
  "play_1a47eaa7": {
    "message": "Reproduzir"
  },
  "play_media_comment_35257210": {
    "message": "Reproduzir comentário em mídia."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "Reproduzir comentário em mídia por { name } de { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "Configuração do jogador"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "Permita que o Canvas acesse o seu microfone e sua webcam."
  },
  "please_choose_a_file_c2449cc": {
    "message": "Por favor, escolha um arquivo"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "Por favor insira o nome do arquivo."
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "Insira um URL de vídeo válido de uma plataforma compatível."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "Selecione um arquivo de um tipo compatível"
  },
  "plus_d43cd4ec": {
    "message": "Mais"
  },
  "plus_minus_f8be2e83": {
    "message": "Mais/menos"
  },
  "posted_when_a578f5ab": {
    "message": "Postado: { when }"
  },
  "power_set_4f26f316": {
    "message": "Conjunto de força"
  },
  "precedes_196b9aef": {
    "message": "Precede"
  },
  "precedes_equal_20701e84": {
    "message": "Precede igual"
  },
  "preformatted_d0670862": {
    "message": "Pré-formatado"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "Ant"
  },
  "preview_53003fd2": {
    "message": "Pré-visualização"
  },
  "preview_a3f8f854": {
    "message": "PRÉ-VISUALIZAÇÃO"
  },
  "preview_in_overlay_ed772c46": {
    "message": "Pré-visualizar na sobreposição"
  },
  "preview_inline_9787330": {
    "message": "Pré-visualizar em linha"
  },
  "previous_bd2ac015": {
    "message": "Anterior"
  },
  "previous_findtext_8dfbfd30": {
    "message": "{ findText } anterior"
  },
  "previously_chosen_colors_f1338315": {
    "message": "Cores escolhidas anteriormente"
  },
  "prime_917ea60e": {
    "message": "Melhor"
  },
  "prime_numbers_13464f61": {
    "message": "Números primos"
  },
  "product_39cf144f": {
    "message": "Produto"
  },
  "proportional_f02800cc": {
    "message": "Proporcional"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "Protocolo deve ser ftp, http, https, mailto, skype, tel ou pode ser omitido"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "publicado"
  },
  "published_when_302d8e23": {
    "message": "Publicado: { when }"
  },
  "pumpkin_904428d5": {
    "message": "Abóbora"
  },
  "purple_7678a9fc": {
    "message": "Roxo"
  },
  "quaternions_877024e0": {
    "message": "Quaternions"
  },
  "quiz_e0dcce8f": {
    "message": "Teste"
  },
  "quizzes_7e598f57": {
    "message": "Testes"
  },
  "rational_numbers_80ddaa4a": {
    "message": "Números racionais"
  },
  "real_numbers_7c99df94": {
    "message": "Numeros reais"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "Parcela real (de número complexo)"
  },
  "record_7c9448b": {
    "message": "Gravar"
  },
  "record_upload_media_5fdce166": {
    "message": "Gravar/fazer upload de mídia"
  },
  "recording_98da6bda": {
    "message": "Gravação"
  },
  "red_8258edf3": {
    "message": "Vermelho"
  },
  "relationships_6602af70": {
    "message": "Relacionamentos"
  },
  "religion_icon_246e0be1": {
    "message": "Ícone de religião"
  },
  "remove_f47dc62a": {
    "message": "Remover"
  },
  "remove_filename_3ea029f6": {
    "message": "Remover { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "Remover estilo do título"
  },
  "remove_link_d1f2f4d0": {
    "message": "Remover link"
  },
  "replace_all_d3d68b3": {
    "message": "Substituir todos"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "Substituir todos { findText } por { replaceText }"
  },
  "replace_e61834a7": {
    "message": "Substituir"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "Substituir { findText } por { replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "Substituir por"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "Substituído { alertFindText } por { alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "Substituído todos { alertFindText } por { alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "Redefinir"
  },
  "resize_ec83d538": {
    "message": "Redimensionar"
  },
  "restore_auto_save_deccd84b": {
    "message": "Restaurar salvamento automático?"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "Resultado { index } de { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Catraca reversa (não cede)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (Variante)"
  },
  "rich_content_editor_2708ef21": {
    "message": "Editor de conteúdo avançado"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "Área de conteúdo enriquecido. Pressione { OSKey }+F8 para atalhos do Rich Content Editor."
  },
  "right_71ffdc4d": {
    "message": "Direita"
  },
  "right_align_39e7a32a": {
    "message": "Alinhar à direita"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Suporte de ângulo reto"
  },
  "right_arrow_35e0eddf": {
    "message": "Seta direita"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Seta para a direita com gancho"
  },
  "right_ceiling_839dc744": {
    "message": "Teto direito"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Chave curva direita"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Arpão para a direita para baixo"
  },
  "right_floor_5392d5cf": {
    "message": "Piso direito"
  },
  "right_to_left_9cfb092a": {
    "message": "Direita à esquerda"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Arpão para a direita para cima"
  },
  "rightward_arrow_32932107": {
    "message": "Seta para a direita"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "Triângulo apontando para a direita"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "Girar imagem -90 graus"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "Girar imagem 90 graus"
  },
  "rotation_9699c538": {
    "message": "Rotação"
  },
  "row_fc0944a7": {
    "message": "Linha"
  },
  "row_group_979f5528": {
    "message": "Grupo de linhas"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "Infelizmente, o lindo editor de HTML não é acessível por teclado. Acesse o editor de HTML bruto aqui."
  },
  "save_11a80ec3": {
    "message": "Salvar"
  },
  "save_copy_ca63944e": {
    "message": "Salvar cópia"
  },
  "save_media_cb9e786e": {
    "message": "Salvar mídia"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "Ícones salvos do criador de ícones"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "Leitores de tela não podem determinar o que é exibido em uma imagem sem texto alternativo, e nomes de arquivos geralmente são strings sem significados de números e letras que não descrevem o contexto ou significado."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "Leitores de tela não podem determinar o que é exibido em uma imagem sem texto alternativo, que descreve o conteúdo e significado da imagem. Texto alternativo deve ser simples e conciso."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "Leitores de tela não podem determinar o que é exibido em uma imagem sem texto alternativo, que descreve o conteúdo e significado da imagem."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "Leitores de tela não podem interpretar tabelas sem a estrutura adequada. Cabeçalhos de tabelas fornecem direção e âmbito do conteúdo."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "Leitores de tela não podem interpretar tabelas sem a estrutura adequada. Legendas de tabelas descrevem o contexto e entendimento geral da tabela."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "Leitores de tela não podem interpretar tabelas sem a estrutura adequada. Cabeçalhos de tabelas fornecem direção e visão geral do conteúdo."
  },
  "script_l_42a7b254": {
    "message": "Roteiro L"
  },
  "search_280d00bd": {
    "message": "Pesquisar"
  },
  "select_audio_source_21043cd5": {
    "message": "Selecionar a fonte de áudio"
  },
  "select_crop_shape_d441feeb": {
    "message": "Selecionar a forma de corte"
  },
  "select_language_7c93a900": {
    "message": "Selecionar idioma"
  },
  "select_video_source_1b5c9dbe": {
    "message": "Selecionar a fonte de vídeo"
  },
  "selected_274ce24f": {
    "message": "Selecionado"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "Selecionado { linkFileName }"
  },
  "selection_b52c4c5e": {
    "message": "Seleção"
  },
  "set_header_scope_8c548f40": {
    "message": "Definir âmbito do cabeçalho"
  },
  "set_minus_b46e9b88": {
    "message": "Definir menos"
  },
  "set_table_header_cfab13a0": {
    "message": "Definir cabeçalho da tabela"
  },
  "sharp_music_ab956814": {
    "message": "Sustenido (Música)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+Setas"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "Shift-O para abrir o lindo editor de html."
  },
  "shortcut_911d6255": {
    "message": "Atalho"
  },
  "show_image_options_1e2ecc6b": {
    "message": "Exibir opções de imagem"
  },
  "show_link_options_545338fd": {
    "message": "Exibir opções de link"
  },
  "show_rolling_transcript_c1481744": {
    "message": "Show em andamento transcrição"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "Mostrar transcrição contínua"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "Deficientes visuais navegam rapidamente nas páginas web, buscando títulos grandes ou negritos. Usuários de leitores de tela dependem dos cabeçalhos para entendimento contextual. Os cabeçalhos devem usar a estrutura adequada."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "Deficientes visuais navegam rapidamente nas páginas web, buscando títulos grandes ou negritos. Usuários de leitores de tela dependem dos cabeçalhos para entendimento contextual. Os cabeçalhos devem ser concisos dentro da estrutura adequada."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (variante)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "Imagem de cor única"
  },
  "single_color_image_color_95fa9a87": {
    "message": "Cor da imagem de cor única"
  },
  "size_b30e1077": {
    "message": "Tamanho"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "O tamanho do arquivo de legenda é maior do que o tamanho máximo de arquivo permitido em { max } kb."
  },
  "small_b070434a": {
    "message": "Pequena"
  },
  "small_width_x_height_px_359acd38": {
    "message": "Pequeno ({ width } x { height } px)"
  },
  "solid_circle_9f061dfc": {
    "message": "Círculo sólido"
  },
  "something_went_wrong_89195131": {
    "message": "Algo deu errado."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "Algo deu errado ao acessar a sua webcam."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "Algo deu errado e não sei o que mostrar."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "Algo deu errado. Verifique sua conexão, recarregue a página e tente novamente."
  },
  "something_went_wrong_d238c551": {
    "message": "Algo deu errado"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "Algo deu errado ao compartilhar sua tela."
  },
  "sort_by_e75f9e3e": {
    "message": "Ordenar por"
  },
  "spades_suit_b37020c2": {
    "message": "Espadas (naipe)"
  },
  "square_511eb3b3": {
    "message": "Quadrado"
  },
  "square_cap_9ec88646": {
    "message": "Tampa quadrada"
  },
  "square_cup_b0665113": {
    "message": "Taça quadrada"
  },
  "square_root_e8bcbc60": {
    "message": "Raiz quadrada"
  },
  "square_root_symbol_d0898a53": {
    "message": "Símbolo de raiz quadrada"
  },
  "square_subset_17be67cb": {
    "message": "Subconjunto quadrado"
  },
  "square_subset_strict_7044e84f": {
    "message": "Subconjunto quadrado (estrito)"
  },
  "square_superset_3be8dae1": {
    "message": "Superconjunto quadrado"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Superconjunto quadrado (estrito)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "Lista não ordenada quadrada"
  },
  "star_8d156e09": {
    "message": "Adicionar aos favoritos"
  },
  "start_over_f7552aa9": {
    "message": "Reiniciar"
  },
  "start_recording_9a65141a": {
    "message": "Iniciar gravação"
  },
  "steel_blue_14296f08": {
    "message": "Azul aço"
  },
  "studio_media_options_ee504361": {
    "message": "Opções de mídia do Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "Bandeja de opções de mídia do Studio"
  },
  "styles_2aa721ef": {
    "message": "Estilos"
  },
  "submit_a3cc6859": {
    "message": "Enviar"
  },
  "submitting_b90fac62": {
    "message": "Enviando..."
  },
  "subscript_59744f96": {
    "message": "Subscrito"
  },
  "subset_19c1a92f": {
    "message": "Subconjunto"
  },
  "subset_strict_8d8948d6": {
    "message": "Subconjunto (estrito)"
  },
  "succeeds_9cc31be9": {
    "message": "Sucesso"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Sucesso igual"
  },
  "sum_b0842d31": {
    "message": "Soma"
  },
  "superscript_8cb349a2": {
    "message": "Sobrescrito"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "Sobrescrito e subscrito"
  },
  "superset_c4db8a7a": {
    "message": "Superconjunto"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superconjunto (estrito)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "Tipos de arquivos suportados: SRT ou WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "Alternar para um belo editor de HTML"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "Alternar para o editor HTML bruto"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "Mudar para o editor html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "Mudar para o rich text editor"
  },
  "syllabus_f191f65b": {
    "message": "Programa"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "Áudio do sistema ativado"
  },
  "system_audio_disabled_c177bd13": {
    "message": "Áudio do sistema desativado"
  },
  "tab_arrows_4cf5abfc": {
    "message": "TAB/Setas"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "Cabeçalho de tabela começando com { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "Tabela começando com { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "Cabeçalhos de tabela devem especificar o âmbito."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "Tabelas devem incluir uma legenda descrevendo o conteúdo da tabela."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "Tabelas devem incluir pelo menos um cabeçalho."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "Cerceta"
  },
  "text_7f4593da": {
    "message": "Texto"
  },
  "text_background_color_16e61c3f": {
    "message": "Cor de fundo do texto"
  },
  "text_color_acf75eb6": {
    "message": "Cor do texto"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "Texto é difícil de ler sem contraste suficiente entre o texto e o plano de fundo, especialmente para aqueles com pouca visão."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "Texto maior do que 18pt (ou negrito 14pt) deve exibir uma razão mínima de contraste de 3:1."
  },
  "text_optional_384f94f7": {
    "message": "Texto (opcional)"
  },
  "text_position_8df8c162": {
    "message": "Posição do texto"
  },
  "text_size_887c2f6": {
    "message": "Tamanho do texto"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "Texto menor do que 18pt (ou negrito 14pt) deve exibir uma razão mínima de contraste de 4.5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "No momento, a pré-visualização do documento está sendo processada. Por favor, tente novamente mais tarde."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "O primeiro cabeçalho em uma página deve ser um H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "A altura da área de conteúdo avançado é reduzida."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "A altura da área de conteúdo avançado é aumentada."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "O material está no domínio público"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "O material está licenciado sob Creative Commons"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "O material está sujeito a uma exceção, por exemplo, uso justo, o direito de citar ou outros sob leis de direitos autorais"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "O lindo editor de html não é acessível por teclado. Pressione Shift+O para abrir o editor de HTML bruto."
  },
  "therefore_d860e024": {
    "message": "Portanto"
  },
  "theta_ce2d2350": {
    "message": "Teta"
  },
  "theta_variant_fff6da6f": {
    "message": "Teta (Variante)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Seta para baixo grossa"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Seta grossa para a esquerda"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Seta grossa para a esquerda"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Seta grossa para a direita"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Seta grossa para a direita"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Seta grossa para cima"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "Esse documento não pode ser exibido dentro do Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "Esta equação não pode ser entregue em exibição básica"
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "Esta imagem está atualmente indisponível"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "Este vídeo pode exibir anúncios do YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "Embora o seu vídeo tenha o título correto no navegador, falhamos em atualizá-lo no banco de dados."
  },
  "thumbnail_e0de666f": {
    "message": "Miniatura"
  },
  "timebar_a4d18443": {
    "message": "Barra do tempo"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "O título não pode estar em branco"
  },
  "title_ee03d132": {
    "message": "Título"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "A ser postado: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "Para fazer: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "Alternar { summary } grupo"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "Alternar dica da ferramenta"
  },
  "tools_2fcf772e": {
    "message": "Ferramentas"
  },
  "top_66e0adb6": {
    "message": "Superior"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "O painel de transcrição está disponível em larguras acima de 720px."
  },
  "tray_839df38a": {
    "message": "Bandeja"
  },
  "triangle_6072304e": {
    "message": "Triângulo"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Catraca (Rendimentos)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "digite Control F9 para acessar opções de imagem. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "digite Control F9 para acessar opções de link. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "digite Control F9 para acessar opções de tabela. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "Não é possível determinar o URL de seleção de recursos"
  },
  "underline_applied_ae01ec97": {
    "message": "Sublinhado aplicado"
  },
  "underline_removed_3693e17c": {
    "message": "Sublinhado removido"
  },
  "union_e6b57a53": {
    "message": "Sindicato"
  },
  "unpublished_dfd8801": {
    "message": "não publicado"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "As alterações não salvas serão perdidas."
  },
  "untitled_16aa4f2b": {
    "message": "Sem título"
  },
  "untitled_efdc2d7d": {
    "message": "sem título"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Seta diagonal para cima e para a esquerda"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Seta diagonal para cima e para a direita"
  },
  "up_c553575d": {
    "message": "Para Cima"
  },
  "updated_link_a827e441": {
    "message": "Link atualizado"
  },
  "upload_document_253f0478": {
    "message": "Carregar documento"
  },
  "upload_file_fd2361b8": {
    "message": "Carregar arquivo"
  },
  "upload_image_6120b609": {
    "message": "Carregar imagem"
  },
  "upload_media_ce31135a": {
    "message": "Fazer Upload de Mídia"
  },
  "upload_record_media_e4207d72": {
    "message": "Carregar/Gravar mídia"
  },
  "uploading_19e8a4e7": {
    "message": "Carregando"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "Lista ordenada alfabeticamente e letras maiúsculas"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Delta maiúsculas"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Gama maiúscula"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Lambda maiúscula"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Ômega maiúscula"
  },
  "uppercase_phi_caa36724": {
    "message": "Phi maiúsculo"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Pi maiúsculo"
  },
  "uppercase_psi_6395acbe": {
    "message": "Psi maiúsculo"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "Lista ordenada numérica e romana com letras maiúsculas"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Sigma maiúsculo"
  },
  "uppercase_theta_49afc891": {
    "message": "Teta maiúsculo"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Upsilon maiúsculo"
  },
  "uppercase_xi_341e8556": {
    "message": "Xi maiúsculo"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Seta apontando para cima e para baixo"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Seta apontando para cima e para baixo (grossa)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Seta para cima"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "Triângulo apontando para cima"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "Direito de uso:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "Direitos de uso (obrigatório)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "Use teclas de setas para navegar entre as opções."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "Use as setas para selecionar uma forma."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "Use as setas para selecionar um tamanho."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "Use as setas para selecionar a posição do texto."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "Use as setas para selecionar o tamanho do texto."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "Use as setas para selecionar um tamanho de contorno."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "Usado por leitores de tela para descrever o conteúdo de uma { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "Usado por leitores de tela para descrever o conteúdo de uma imagem"
  },
  "user_documents_c206e61f": {
    "message": "Documentos do usuário"
  },
  "user_files_78e21703": {
    "message": "Arquivos do usuário"
  },
  "user_images_b6490852": {
    "message": "Imagens do usuário"
  },
  "user_media_14fbf656": {
    "message": "Mídia do usuário"
  },
  "vector_notation_cf6086ab": {
    "message": "Vetor (notação)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "Barra vertical (notação do construtor de conjuntos)"
  },
  "vertical_dots_bfb21f14": {
    "message": "Pontos verticais"
  },
  "video_options_24ef6e5d": {
    "message": "Opções de vídeo"
  },
  "video_options_tray_3b9809a5": {
    "message": "Bandeja de opções de vídeo"
  },
  "video_player_b371005": {
    "message": "Reprodutor de Vídeo"
  },
  "video_player_for_9e7d373b": {
    "message": "Reprodutor de vídeo para "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "Reprodutor de vídeo para { title }"
  },
  "video_url_889d3263": {
    "message": "URL do vídeo"
  },
  "view_all_e13bf0a6": {
    "message": "Visualizar todos"
  },
  "view_ba339f93": {
    "message": "Visualizar"
  },
  "view_description_30446afc": {
    "message": "Ver descrição"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "Visualizar atalhos de teclado"
  },
  "view_title_description_67940918": {
    "message": "Ver { title } descrição"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "Exibir contagens de palavras e caracteres"
  },
  "viewer_restrictions_e14274c9": {
    "message": "Restrições do visualizador"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "Não foi possível detectar um microfone funcionando conectado ao seu dispositivo."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "Não foi possível detectar uma webcam funcionando conectada ao seu dispositivo."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "Não foi possível detectar uma webcam ou microfone funcionando conectado ao seu dispositivo."
  },
  "webcam_disabled_30c66986": {
    "message": "Webcam desativada"
  },
  "webcam_fe91b20f": {
    "message": "Webcam"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "As páginas da Web devem ter apenas um único H1, que é usado automaticamente pelo título da página. O primeiro cabeçalho do seu conteúdo deve ser um H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "Quando marcação é usada, que visualmente formata itens como uma lista, mas não indica o relacionamento da lista, os usuários podem ter dificuldade em navegar pelas informações."
  },
  "white_87fa64fd": {
    "message": "Branco"
  },
  "why_523b3d8c": {
    "message": "Por que"
  },
  "width_492fec76": {
    "message": "Largura"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "Largura e altura devem ser números"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height }px"
  },
  "wiki_home_9cd54d0": {
    "message": "Página inicial do wiki"
  },
  "word_count_c77fe3a6": {
    "message": "Contagem de palavras"
  },
  "words_b448b7d5": {
    "message": "Faladas"
  },
  "wreath_product_200b38ef": {
    "message": "Produto de guirlanda"
  },
  "xi_149681d0": {
    "message": "XI"
  },
  "yes_dde87d5": {
    "message": "Sim"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "Você está em uma paleta de cores. Para navegar na paleta para cima, para a esquerda, para baixo ou para a direita, use os botões ''W'', ''A'', ''S'' e ''D'', respectivamente"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "Você está em um controle deslizante de cores. Para navegar no controle deslizante para a esquerda ou para a direita, use os botões ''A'' e ''D'', respectivamente"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "Você está em um controle deslizante alfa. Para navegar no controle deslizante para a esquerda ou para a direita, use os botões ''A'' e ''D'', respectivamente"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "Você tem alterações não salvas na bandeja do Criador de Ícones. Você deseja continuar sem salvar essas alterações?"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "Pode ser necessário ajustar cabeçalhos adicionais para manter a hierarquia da página."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "Você não pode carregar um arquivo vazio."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "Sua imagem foi compactada para o Criador de Ícones. Imagens com menos de { size } KB não serão compactadas."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "Seu microfone está bloqueado nas configurações do navegador."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "Sua webcam e microfone estão bloqueados nas configurações do navegador."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "Sua webcam está bloqueada nas configurações do navegador."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "Sua webcam já pode estar em uso."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "URL integrado do YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "Ampliar imagem"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "Reduzir imagem"
  }
};
formatMessage.addLocale({
  'pt-BR': locale
});